import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppLayoutSecureService } from '../../layout/secure/secure.service';
import { ApiAuthService } from '@app/api';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class AppHomeComponent implements OnInit, OnDestroy {
  links: any = [
    {
      icon: 'map',
      link: ['/travel'],
      title: 'Gestion des voyages',
      color: '#27ae60',
      permissions: ['TRAVEL_LIST'],
    },
    {
      icon: 'mail',
      link: '/mail',
      title: 'Gestion des emails',
      color: '#3498db',
      permissions: ['MAIL_LIST'],
    },
    {
      icon: 'live_help',
      link: ['/support'],
      title: 'Gestion du support',
      color: '#e74c3c',
      permissions: ['SUPPORT_LIST'],
    },
    {
      icon: 'sms',
      link: ['/sms'],
      title: 'Gestion des sms',
      color: '#8e44ad',
      permissions: ['SMS_LIST'],
    },
    {
      icon: 'people',
      link: ['/user'],
      title: 'Gestion des utilisateurs',
      color: '#e67e22',
      permissions: ['USER_LIST'],
    },
    {
      icon: 'settings',
      link: ['/parameter'],
      title: 'Gestion des paramètres',
      color: '#2c3e50',
      permissions: ['PARAMETER_LIST'],
    },
  ];

  cols$: Observable<number> = this._breakpointObserver
    .observe([Breakpoints.Small, Breakpoints.XSmall, Breakpoints.Medium])
    .pipe(
      map((result) => {
        if (
          result.breakpoints[Breakpoints.Small] ||
          result.breakpoints[Breakpoints.XSmall]
        ) {
          return 1;
        } else if (result.breakpoints[Breakpoints.Medium]) {
          return 2;
        } else {
          return 3;
        }
      }),
      shareReplay()
    );

  constructor(
    private _breakpointObserver: BreakpointObserver,
    private _appLayoutSecure: AppLayoutSecureService,
    private _router: Router,
    private _apiAuth: ApiAuthService
  ) {}

  get activeLinks() {
    return this.links.filter((item: any) =>
      this._apiAuth.hasPermissions(item.permissions)
    );
  }

  ngOnInit() {
    this._appLayoutSecure.showRecall = true;
  }

  ngOnDestroy() {
    this._appLayoutSecure.showRecall = false;
  }

  popupAction(link: any) {
    const url = this._router.serializeUrl(this._router.createUrlTree(link));
    window.open(
      url,
      'recall',
      'toolbar=yes,scrollbars=yes,resizable=yes,top=0,left=0,width=4000,height=4000'
    );
  }
}
